import { render, staticRenderFns } from "./loginForm.vue?vue&type=template&id=07270840&scoped=true&"
import script from "./loginForm.vue?vue&type=script&lang=js&"
export * from "./loginForm.vue?vue&type=script&lang=js&"
import style0 from "./loginForm.vue?vue&type=style&index=0&id=07270840&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07270840",
  null
  
)

export default component.exports